var UserEvent;
(function (UserEvent) {
    UserEvent[UserEvent["TRADE_IN_DEFINED"] = 0] = "TRADE_IN_DEFINED";
    UserEvent[UserEvent["TRADE_IN_SKIPPED"] = 1] = "TRADE_IN_SKIPPED";
    UserEvent[UserEvent["PAYMENT_TYPE_CASH_CHOSEN"] = 2] = "PAYMENT_TYPE_CASH_CHOSEN";
    UserEvent[UserEvent["PAYMENT_TYPE_LEASING_CHOSEN"] = 3] = "PAYMENT_TYPE_LEASING_CHOSEN";
    UserEvent[UserEvent["PAYMENT_TYPE_LOAN_CHOSEN"] = 4] = "PAYMENT_TYPE_LOAN_CHOSEN";
    UserEvent[UserEvent["INSURANCE_ADDED"] = 5] = "INSURANCE_ADDED";
    UserEvent[UserEvent["INSURANCE_SKIPPED"] = 6] = "INSURANCE_SKIPPED";
    UserEvent[UserEvent["CUSTOMER_DETAILS_AUTOMATIC_CHOSEN"] = 7] = "CUSTOMER_DETAILS_AUTOMATIC_CHOSEN";
    UserEvent[UserEvent["CUSTOMER_DETAILS_MANUAL_CHOSEN"] = 8] = "CUSTOMER_DETAILS_MANUAL_CHOSEN";
    UserEvent[UserEvent["DELIVERY_TYPE_PICKUP_CHOSEN"] = 9] = "DELIVERY_TYPE_PICKUP_CHOSEN";
    UserEvent[UserEvent["DELIVERY_TYPE_DELIVERY_CHOSEN"] = 10] = "DELIVERY_TYPE_DELIVERY_CHOSEN";
    UserEvent[UserEvent["ORDER_CREATED"] = 11] = "ORDER_CREATED";
    UserEvent[UserEvent["ORDER_CANCELLED"] = 12] = "ORDER_CANCELLED";
    UserEvent[UserEvent["BACK_BUTTON_CLICKED"] = 13] = "BACK_BUTTON_CLICKED";
})(UserEvent || (UserEvent = {}));
export default UserEvent;
